import { render } from "./AlerteDoublons.vue?vue&type=template&id=5d3a47b3"
import script from "./AlerteDoublons.vue?vue&type=script&lang=js"
export * from "./AlerteDoublons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__